import * as React from 'react';
import { CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-react';
import type { Severity } from 'types/severity';

type AlertProps = {
  readonly text: string;
  readonly severity: Severity;
  readonly onClose?: () => void;
};

const severityToContainerStyles: Record<Severity, string> = {
  success: 'bg-[#20a18b]',
  info: 'bg-[#2a3992]',
  warning: 'bg-[#c46c08]',
  danger: 'bg-[#ae170f]',
};

const severityToIcon: Record<Severity, React.ComponentType<{ className?: string }>> = {
  success: CircleCheck,
  info: Info,
  warning: TriangleAlert,
  danger: CircleAlert,
};

function Alert({ text, severity, onClose }: AlertProps) {
  const SeverityIcon = severityToIcon[severity];

  return (
    <div
      className={`relative flex items-center gap-2.5 rounded-lg px-4 py-3 text-white ${severityToContainerStyles[severity]}`}
    >
      <SeverityIcon className="h-5 w-5 shrink-0" />
      <span className="flex-1 text-sm leading-5 text-white">{text}</span>
      {onClose && (
        <button
          type="button"
          className="-mt-1 -mr-1.5 -mb-1 ml-0 flex shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-1 text-white opacity-75 transition-opacity duration-150 ease-in-out hover:opacity-100 [&>svg]:h-4 [&>svg]:w-4"
          aria-label="Fermer"
          onClick={event => {
            event.stopPropagation();
            onClose();
          }}
        >
          <X />
        </button>
      )}
    </div>
  );
}

export type { AlertProps };
export { Alert };
